import React, { useRef } from 'react';
import Sticky from 'Components/Sticky';
import ActionLoader from 'Components/ActionLoader';
import TripDetailsPanel from './components/TripDetailsPanel';
import TripMap from './components/TripMap';
import MapLayersDrawer from './components/MapLayersDrawer';
import FullscreenButton from './components/FullscreenButton';
import { useTrackTrip } from './hooks/useTrackTrip';
import { useLegend } from './hooks/useLegend';
import { useRoutes } from './hooks/useRoutes';
import { useFastTag } from './hooks/useFastTag';
import { useMapLayers } from './hooks/useMapLayers';
import { useMeasureTool } from './hooks/useMeasureTool';
import { getTruckColor } from './utils/legend';
import styles from './TripTrackingV2.module.scss';

const onSearch = (value) => {
  localStorage.setItem('teg-component', true);
  location.href = '/trips?search=' + value;
};

const TripTrackingV2 = ({ match }) => {
  const tripId = match.params.id;
  const mapWrapperRef = useRef(null);

  const { trip, isLoaded } = useTrackTrip(tripId);
  const { routeLegend, truckLegend, pingLegend, routePointLegend } = useLegend();
  const routes = useRoutes(tripId);
  const fastTagPoints = useFastTag(tripId);
  const locations = trip ? (trip.locations || []) : [];

  const {
    isMeasuring, measurePoints, toggleMeasuring, addMeasurePoint, clearMeasurement, distanceLabel,
  } = useMeasureTool();

  const { layerOptions, handleLayerToggle, visibleRoutes, visibleLocations, showGeofence } = useMapLayers({
    routes,
    locations,
    routeLegend,
    truckLegend,
    pingLegend,
    routePointLegend,
    isMeasuring,
    onToggleMeasuring: toggleMeasuring,
  });

  return (
    <Sticky activeLink="tracking" onSearch={onSearch}>
      <div className={styles.page}>
        {!isLoaded && <ActionLoader fixed />}
        {isLoaded && trip && trip.tripId && (
          <>
            <TripDetailsPanel trip={trip} />
            <div className={styles.mapWrapper} ref={mapWrapperRef}>
              <MapLayersDrawer layers={layerOptions} onToggle={handleLayerToggle} />
              <FullscreenButton targetRef={mapWrapperRef} />
              {distanceLabel && (
                <div className={styles.measureReadout}>
                  <span>{distanceLabel}</span>
                  <button type="button" className={styles.measureReadoutClear} onClick={clearMeasurement}>Clear</button>
                </div>
              )}
              <TripMap
                routes={visibleRoutes}
                routeLegend={routeLegend}
                pingLegend={pingLegend}
                routePointLegend={routePointLegend}
                locations={visibleLocations}
                fastTagPoints={fastTagPoints}
                source={trip.source}
                destination={trip.destination}
                lastKnownLocation={trip.lastKnownLocation}
                vehicleColor={getTruckColor(trip.type, trip.sub_type, truckLegend)}
                showGeofence={showGeofence}
                isMeasuring={isMeasuring}
                measurePoints={measurePoints}
                onAddMeasurePoint={addMeasurePoint}
              />
            </div>
          </>
        )}
        {isLoaded && (!trip || !trip.tripId) && (
          <div className={styles.emptyState}>No trip found for tracking</div>
        )}
      </div>
    </Sticky>
  );
};

export default TripTrackingV2;
